// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import utilities
import { getDOMElements } from '@automator/builder/_legacy/js/common/utilities';

// Load class that creates the grid with integrations
import ItemCreatorIntegrations from '@automator/builder/_legacy/js/item/integrations-grid';

/**
 * Adds the initial "Add action" button (when there aren't actions)
 */
export default class ItemInitialAction {
	/**
	 * Renders the item
	 * 
	 * @return {undefined}
	 */
	constructor() {
		// Create template
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item', 'uap-item--actions-initial' );

		// Add content
		$template.insertAdjacentHTML( 'beforeEnd', `
			<div class="uap-item-inner">
				<div class="uap-item-sidebar">
					<div class="uap-item-icon"></div>
				</div>
				<div class="uap-item-main">
					<uo-button
						color="secondary"
						size="small"
						class="uap-item-main-initial-action-button uap-spacing-right uap-spacing-right--xsmall"
					>
						${ escapeHTML( __( 'Add action', 'uncanny-automator' ) ) }
					</uo-button>

					<uo-button-dropdown class="add-action-btn">
						<uo-button 
							slot="target" 
							color="secondary"
							size="small"
						>
							${ escapeHTML( __( 'Add', 'uncanny-automator' ) ) } <uo-icon id="angle-down"></uo-icon>
						</uo-button>

						<ua-builder-conditions-add-button 
							size="small"
							color="transparent"
						>
							${ escapeHTML( __( 'Filter', 'uncanny-automator' ) ) }
						</ua-builder-conditions-add-button>

						<uap-builder-loop-add-user-loop
							size="small"
							color="transparent"
						></uap-builder-loop-add-user-loop>

						<uap-builder-loop-add-post-loop
							size="small"
							color="transparent"
						></uap-builder-loop-add-post-loop>

						<uap-builder-loop-add-token-loop
										parent-id=${ UncannyAutomator._recipe.recipe_id }
							size="small"
							color="transparent"
						></uap-builder-loop-add-token-loop>

					</uo-button-dropdown>
				</div>
			</div>
		` );

		// Add to the metabox
		const $metabox = getDOMElements( 'metabox', {
			type: 'action',
		} ).get(0);

		$metabox.appendChild( $template );

		// Add event listener to the button
		$template.querySelector( '.uap-item-main-initial-action-button' ).addEventListener( 'click', () => {
			// Show the integrations grid
			new ItemCreatorIntegrations( 'action' );

			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/item-action-initial-clicked' ) );
		} );
	}
}
